import { memo } from 'react';

import {
  FileStatusButton,
  FileStatusIconProgressing,
  FileStatusSubtitle,
  FileStatusTitle,
} from '@air/feature-file-status/ui';
import { Close } from '@air/next-icons';

import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { type ClipVideoTaskMetadata } from '~/components/VideoClipTasks/types';

export type VideoClipTaskPanelItemInProgressProps = {
  metadata: ClipVideoTaskMetadata;
  onCancel: () => void;
};

export const VideoClipTaskPanelItemInProgress = memo(
  ({ metadata, onCancel }: VideoClipTaskPanelItemInProgressProps) => {
    return (
      <PaneItemTW
        avatar={<FileStatusIconProgressing />}
        title={
          <FileStatusTitle data-testid="VIDEO_CLIP_PANEL_IN_PROGRESS_TITLE">
            {metadata?.saveResultAs?.as === 'assetVersion' ? 'Saving video as new version' : 'Saving as new video'}
          </FileStatusTitle>
        }
        subtitle={<FileStatusSubtitle className="truncate">Processing video...</FileStatusSubtitle>}
        buttons={
          <FileStatusButton label="Cancel" onClick={onCancel}>
            <Close className="size-4" />
          </FileStatusButton>
        }
      />
    );
  },
);

VideoClipTaskPanelItemInProgress.displayName = 'VideoClipTaskPanelItemInProgress';
